module.exports = __webpack_public_path__ + "img/CAN.a5aa5368.svg";